import { TransparentButtonLarge } from 'components/button/button.styled'
import { getMonthYearText } from 'utils/event'

import { Container, Text } from './selectMonth.style'

interface Props {
    selectedDate: Date
    onPreviousMonth: () => void
    onNextMonth: () => void
}

export const SelectMonth: React.FC<Props> = ({ selectedDate, onPreviousMonth, onNextMonth }: Props) => {
    return (
        <Container>
            <TransparentButtonLarge icon="pi pi-chevron-left" onClick={onPreviousMonth} />
            <Text>{getMonthYearText(selectedDate)}</Text>
            <TransparentButtonLarge icon="pi pi-chevron-right" onClick={onNextMonth} />
        </Container>
    )
}
